import clsx from 'clsx';
import { ReactNode } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

import styles from './SocialLoginButton.module.css';

interface SocialLoginButtonProps {
  imageSrcOrNode: string | ReactNode;
  text: string;
  onClick: () => void;
  loading: boolean;
  enterFlow2026?: 'googleStyle' | 'appleStyle' | 'facebookStyle';
}
const SocialLoginButton = (props: SocialLoginButtonProps) => {
  return (
    <button
      className={clsx(
        styles.socialLoginButton,
        props.loading && styles.loading,
        props.enterFlow2026 && styles.enterFlow2026,
        props.enterFlow2026 && 'daymadeTypographySMedium',
        props.enterFlow2026 && styles[props.enterFlow2026],
      )}
      onClick={props.onClick}
    >
      <span className={styles.socialLoginButtonInner}>
        {typeof props.imageSrcOrNode === 'string' ? (
          <img
            className={styles.logo}
            src={props.imageSrcOrNode}
            alt={props.text}
          />
        ) : (
          props.imageSrcOrNode
        )}

        <span className={styles.socialLoginButtonText}>{props.text}</span>
        <img
          className={styles.loadingIndicator}
          src={
            props.enterFlow2026 === 'appleStyle' ||
            props.enterFlow2026 === 'facebookStyle'
              ? `${ASSET_PREFIX}/images/spinner-white.svg`
              : `${ASSET_PREFIX}/images/spinner-black.svg`
          }
          alt="Loading..."
        />
      </span>
    </button>
  );
};

export default SocialLoginButton;
